module.exports = __webpack_public_path__ + "img/market.555fd344.png";